import { Navigate } from 'react-router-dom';
import { getRedirectPathByRole } from '../utils/roleRedirect';

export default function PublicRoute({ children }) {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user'));

    if (token && user) {
        return <Navigate to={getRedirectPathByRole(user.roles)} replace />;
    }

    return children;
}
